import { HUB_TYPES } from './stationAdapter';

/**
 * Gas Stations list state in the URL: ?page=2&limit=50&search=shell&hubType=ev.
 * Values are validated and fall back to defaults, so a hand-edited URL can't 400.
 */

export const PAGE_SIZES = [10, 25, 50, 100];
export const MAX_SEARCH_LENGTH = 100;
export const DEFAULT_PARAMS = Object.freeze({ page: 1, limit: 25, search: '', hubType: 'all' });

const intIn = (raw, min, max) => (raw !== null && /^\d+$/.test(raw) && +raw >= min && +raw <= max ? +raw : null);

/** @returns {{ params: { page: number, limit: number, search: string, hubType: string }, invalid: string[] }} */
export function parseStationsParams(searchParams) {
  const invalid = [];
  const pick = (key, value) => {
    if (searchParams.get(key) === null) return DEFAULT_PARAMS[key];
    if (value === null) {
      invalid.push(key);
      return DEFAULT_PARAMS[key];
    }
    return value;
  };
  const rawSearch = searchParams.get('search');
  const search = (rawSearch ?? '').trim().slice(0, MAX_SEARCH_LENGTH);
  if (rawSearch !== null && !search) invalid.push('search');
  const hub = searchParams.get('hubType');

  return {
    params: {
      page: pick('page', intIn(searchParams.get('page'), 1, Number.MAX_SAFE_INTEGER)),
      limit: pick('limit', intIn(searchParams.get('limit'), 1, 100)),
      search,
      hubType: pick('hubType', HUB_TYPES.includes(hub) ? hub : null),
    },
    invalid,
  };
}

/** URL query string; defaults are left out. */
export function toQueryString({ page, limit, search, hubType }) {
  const qs = new URLSearchParams();
  if (page !== DEFAULT_PARAMS.page) qs.set('page', String(page));
  if (limit !== DEFAULT_PARAMS.limit) qs.set('limit', String(limit));
  if (search) qs.set('search', search);
  if (hubType !== DEFAULT_PARAMS.hubType) qs.set('hubType', hubType);
  return qs.toString();
}

/** Any change other than the page itself goes back to page 1. */
export function updateParams(current, changes) {
  const next = { ...current, ...changes };
  if (!Object.keys(changes).every((k) => k === 'page')) next.page = 'page' in changes ? changes.page : 1;
  return next;
}
